function titleNav() {
  return (
    <header className='card'>
      <div className='row'>
        <div className='s12 m12 l12'>
          <h1>Kipling C. Dunlap</h1>
          <ul className="contact tabs black-text center-align">
            {/* <li className="tab"><a href="tel:+14045906275">404.590.6275</a></li> */}
            <li className="tab"><a href="mailto:Kip@KipDunlap.me">Kip@KipDunlap.me</a></li>
            <li className="tab"><a href="https://github.com/UrbaneD0ge" target="_blank" rel="noreferrer">Github</a></li>
            <li className="tab"><a href="https://www.linkedin.com/in/kiplingdunlap/"
              target="_blank" rel="noreferrer">LinkedIn</a>
            </li>
            <li className="tab"><a href="https://bsky.app/profile/kipdunlap.me" target="_blank" rel="noreferrer">BlueSky</a></li>
            <li className="tab"><a href="https://docs.google.com/document/d/1kV6fPIOeblYgp_2rdD9iy71cYNYIZnO7u1hNgb42Vus/edit?usp=sharing"
              target="_blank" rel="noreferrer">Resume</a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default titleNav;